import { motion } from "framer-motion";
import { Reveal, MaskedLine, EASE } from "./Reveal";

const PHRASES = [
  ["Preghi.", "Ma procrastini."],
  ["Ami Dio.", "Ma continui a combattere da solo."],
  ["Conosci la Parola.", "Ma il corpo, le abitudini e la disciplina raccontano un'altra storia."],
];

const PLACES = ["Nella giornata", "Nel corpo", "Nella mente", "Nelle abitudini", "Nelle relazioni", "Nelle scelte"];

export const Problem = () => (
  <section className="relative bg-night px-5 py-32 sm:px-8 lg:py-44" data-testid="problem-section">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
    <div className="mx-auto max-w-5xl">
      {PHRASES.map(([a, b], i) => (
        <motion.div
          key={a}
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-25%" }}
          transition={{ duration: 1, ease: EASE }}
          className="py-14 text-center sm:py-20"
          data-testid={`problem-phrase-${i + 1}`}
        >
          <p className="font-display text-3xl font-bold uppercase tracking-tight text-ivory sm:text-5xl">{a}</p>
          <p className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-ivory/30 sm:text-5xl">{b}</p>
        </motion.div>
      ))}

      <div className="mt-16 border-t border-ivory/10 pt-24">
        <Reveal>
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-gold">Il punto di svolta</p>
        </Reveal>
        <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl" data-testid="problem-headline">
          <MaskedLine delay={0.1}>È qui che inizia</MaskedLine>
          <MaskedLine delay={0.22}>
            <span className="text-gold">il Deserto.</span>
          </MaskedLine>
        </h2>

        <Reveal delay={0.3} className="mt-10 max-w-2xl">
          <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
            Ci sono cristiani che amano sinceramente Dio ma che dal lunedì al sabato combattono da soli
            con pigrizia, pornografia, lussuria, rabbia, alimentazione, procrastinazione, solitudine,
            relazioni, mancanza di disciplina e mancanza di direzione.
          </p>
          <p className="mt-6 text-base leading-relaxed text-ivory/80 sm:text-lg">
            Noi crediamo che la fede debba entrare anche qui.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-2 gap-px bg-ivory/10 sm:grid-cols-3" data-testid="problem-places-grid">
          {PLACES.map((p, i) => (
            <motion.div
              key={p}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="bg-night px-6 py-8"
            >
              <span className="font-display text-lg font-bold uppercase tracking-wide text-ivory/85 sm:text-xl">{p}</span>
              <span className="text-gold">.</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
